module.exports = __webpack_public_path__ + "static/media/rheem-water-heater.6d55a24e.jpg";